"use client";

import { useSelector } from "react-redux";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { accountSelector } from "@/store/account/account.slice";
import { Button } from "../ui/button";
import { Copy } from "../share/copy";
import { compactAddress } from "@/lib/function";
import useHeader from "@/hooks/useHeader";

export default function HeaderAvatar() {
  const { logout } = useHeader();
  const { account } = useSelector(accountSelector);

  const items = [
    {
      key: "1",
      label: (
        <div className="flex justify-between gap-3">
          <b className="text-base font-medium text-gray-500">Tên</b>
          <b className="text-base font-bold text-[#34306a]">{account?.name}</b>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="flex justify-between gap-3">
          <b className="text-base font-medium text-gray-500">Email</b>
          <b className="text-base font-bold text-[#34306a]">{account?.email}</b>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div className="flex justify-between gap-3">
          <b className="text-base font-medium text-gray-500">Địa chỉ ví</b>
          <Copy text={account?.walletAddress}>
            <b className="text-base font-bold text-[#34306a]">
              {compactAddress(account?.walletAddress, 8)}
            </b>
          </Copy>
        </div>
      ),
    },
    {
      key: "4",
      label: (
        <div className="flex justify-between gap-3">
          <b className="text-base font-medium text-gray-500">Số điện thoại</b>
          <b className="text-base font-bold text-[#34306a]">
            {account?.phoneNumber}
          </b>
        </div>
      ),
    },
    {
      key: "5",
      label: (
        <div className="flex justify-between gap-3">
          <b className="text-base font-medium text-gray-500">Vai trò</b>
          <b className="text-[#02893C] flex items-center gap-1">
            {account?.role?.name}
            {/* <IconEge onClick={showModal} className="cursor-pointer" /> */}
          </b>
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <Button
          onClick={logout}
          className="bg-white border border-main text-main w-full hover:bg-white mt-8"
        >
          <div className="flex items-center justify-center gap-1 flex-1">
            <b className="text-base">Logout</b>
            <img src="/logout_main.svg" width={16} height={16} alt="" />
          </div>
        </Button>
      ),
    },
  ];

  return (
    <div>
      <ul className="flex items-center gap-3 m-0">
        <Popover>
          <PopoverTrigger asChild>
            <div>
              <div className="flex justify-center items-center w-10 h-10 rounded-full bg-main text-[24px] leading-none text-white text-center cursor-pointer">
                {account?.name?.charAt(0)}
              </div>
            </div>
          </PopoverTrigger>
          <PopoverContent
            align="end"
            className="w-[400px] bg-white rounded-lg shadow-md border p-4 flex flex-col gap-3 z-50"
          >
            {items?.map((item) => (
              <div key={item.key}>{item.label}</div>
            ))}
          </PopoverContent>
        </Popover>
      </ul>
    </div>
  );
}
